import { BulkFilesPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import BulkFiles from 'modules/documents/components/BulkFiles'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const BulkFilesPage = () => {
  const { loading, data, error } = useQuery(BulkFilesPageDocument, {})

  const authorized =
    !loading &&
    (data?.documents?._policies?.companyUseCompanyDocuments.can ||
      data?.documents?._policies?.employeeManageAnyEmployeeFolder.can)

  const canManageDocumentTemplates =
    data?.documents?._policies?.templateManageDocumentTemplates.can ?? false

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      showHeader={false}
      authorized={authorized}
    >
      <BulkFiles canManageDocumentTemplates={canManageDocumentTemplates} />
    </ResponsivePage.Body>
  )
}

export default BulkFilesPage
